import { Expose, Type } from "class-transformer";
import { BaseContent } from "./BaseContent";

export class ProfitLossData {
  date: Date[] | undefined;
  pf_value: number[] | undefined;
  pf_value_net_of_cost: number[] | undefined;
  benchmark: number[] | undefined;
  index: number[] | undefined;
}

export class ProfitLoss {
  index: string[] | undefined;
  columns: string[] | undefined;
  @Type(() => ProfitLossData)
  data: ProfitLossData | undefined;

  get getDateData() {
    if (this.data?.date) {
      return this.data.date;
    } else {
      return [];
    }
  }
  get getPfData() {
    if (this.data?.pf_value) {
      return this.data.pf_value;
    } else {
      return [];
    }
  }
  get getBenchmarkData() {
    if (this.data?.benchmark) {
      return this.data.benchmark;
    } else {
      return [];
    }
  }
}

export class WeightsData {
  date: Date[] = [];
  symbol: string[] = [];
  weight: number[] = [];

  getEntitiesWeight() {
    if (this.date.length > 0) {
      const entityWeightList = [];
      const lastDay = this.date[this.date.length - 1];
      for (let i = this.date.length - 1; i > 0; i--) {
        if (this.date[i] === lastDay) {
          const symbol = this.symbol[i];
          const weight = this.weight[i];
          entityWeightList.push({
            symbol: symbol,
            weight: weight,
          });
        } else {
          break;
        }
      }
      return entityWeightList;
    }
  }
}

export class Weights {
  index: string[] | undefined;
  columns: string[] | undefined;
  @Type(() => WeightsData)
  data: WeightsData | undefined;
}

export class RebalancingDate {
  date: Date | undefined;
  turnover: number | undefined;
}

export class Content extends BaseContent {
  summary: { [key: string]: string } | undefined;
  entities: string[] | undefined;
  @Type(() => ProfitLoss)
  profit_loss: ProfitLoss | undefined;
  @Type(() => Weights)
  weights: Weights | undefined;
  weighted_by: string | undefined;
  @Type(() => RebalancingDate)
  rebalancing_dates: RebalancingDate[] | undefined;

  get getSummaryAsTable() {
    if (this?.summary != undefined) {
      const summaryData = {
        average_raw_return: [
          parseFloat(this.summary["average portfolio raw returns"]).toFixed(2) +
            "%",
          parseFloat(this.summary["average market raw returns"]).toFixed(2) +
            "%",
        ],
        average_excess_return: [
          parseFloat(this.summary["average portfolio excess returns"]).toFixed(
            2
          ) + "%",
          parseFloat(this.summary["average market excess returns"]).toFixed(2) +
            "%",
        ],
        stdv_raw_return: [
          parseFloat(this.summary["stdev of portfolio raw returns"]).toFixed(2),
          parseFloat(this.summary["stdev of market raw returns"]).toFixed(2),
        ],
        stdv_excess_return: [
          parseFloat(this.summary["stdev of portfolio excess returns"]).toFixed(
            2
          ),
          parseFloat(this.summary["stdev of market excess returns"]).toFixed(2),
        ],
        sharpe_ratio: [
          parseFloat(this.summary["Sharpe ratio of portfolio"]).toFixed(2),
          parseFloat(this.summary["Sharpe ratio of market"]).toFixed(2),
        ],
        capm_alpha: [parseFloat(this.summary["CAPM Alpha"]).toFixed(2), 0],
        capm_beta: [parseFloat(this.summary["CAPM Beta"]).toFixed(2), 1],
        maximum_drawdown: [
          parseFloat(this.summary["portfolio max drawdown"]).toFixed(2) +
            "\n" +
            `(${this.summary["portfolio max drawdown - start"]}~${this.summary["portfolio max drawdown - end"]})`,
          parseFloat(this.summary["market max drawdown"]).toFixed(2) +
            "\n" +
            `(${this.summary["market max drawdown - start"]}~${this.summary["market max drawdown - end"]})`,
          ,
        ],
      };
      return summaryData;
    } else {
      return {};
    }
  }
}
